"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFailure = exports.isError = exports.success = exports.failure = exports.error = void 0;
const types_1 = require("../types");
exports.error = () => ({
    value: null,
    status: types_1.MatchStatus.ERROR,
});
exports.failure = () => ({
    value: null,
    status: types_1.MatchStatus.FAILURE,
});
exports.success = (value) => ({
    value,
    status: types_1.MatchStatus.SUCCESS,
});
exports.isError = (result) => result.status === types_1.MatchStatus.ERROR;
exports.isFailure = (result) => result.status === types_1.MatchStatus.FAILURE;
//# sourceMappingURL=matchStatus.js.map